export const HomeRoute = '/'

export const RequestInfoRoute = '/request-info'
export const PledgeRoute = '/pledge'
export const DashboardRoute = '/dashboard'
export const ConfirmationRoute = '/confirmation'
export const PasswordResetRoute = '/password-reset'
